/**
 * Composable for managing validation state and messages
 * Extracted from FieldHelp and form control components
 */

export function hasValidationError(error) {
  return Array.isArray(error) ? error.some(Boolean) : Boolean(error);
}

export function useValidationState() {
  /**
   * Get the text color class based on validation state
   * @param {boolean|string|array} error - Error state or message
   * @param {boolean|string} success - Success state or message
   * @returns {string|null} CSS class for text color or null
   */
  const getValidationColor = (error, success) => {
    if (hasValidationError(error)) {
      return 'text-theme-danger'
    }
    if (success) {
      return 'text-theme-success'
    }
    return null
  }

  /**
   * Get the help text to display based on error state
   * @param {string} helpText - Default help text
   * @param {boolean|string|array} error - Error state or message
   * @returns {string} Help text to display
   */
  const getHelpText = (helpText, error) => {
    if (!error) {
      return helpText
    }

    if (typeof error === 'string') {
      return error
    }

    // Handle array of errors - return first one
    if (Array.isArray(error)) {
      return error[0] ?? helpText
    }

    // Handle boolean true
    return helpText
  }

  return {
    getValidationColor,
    getHelpText
  }
}
